<template>
  <div>
    <div class="oficina-slide-text" v-html="`&quot;${formattedContent}&quot;`"></div>
    <p v-if="step.subtext" class="oficina-slide-subtext">{{ step.subtext }}</p>
    <div v-if="step.action" class="oficina-slide-action">
      <i class="icofont-info-circle"></i>
      {{ step.action }}
    </div>
    <div v-if="step.tip" class="oficina-slide-tip">
      <i class="icofont-info-circle"></i>
      {{ step.tip }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScriptSlide',
  props: {
    step: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formattedContent() {
      return (this.step.content || '').replace(/\n/g, '<br>')
    },
  },
}
</script>

<style scoped>
.oficina-slide-text {
  font-size: 16px;
  line-height: 1.6;
  color: #1e293b;
  margin-bottom: 24px;
}

.oficina-slide-subtext {
  font-size: 14px;
  color: #64748b;
  margin-top: 16px;
}

.oficina-slide-action {
  background: #eff6ff;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #bfdbfe;
  margin-top: 24px;
  color: #1e40af;
  font-weight: 600;
  font-size: 13px;
}

.oficina-slide-tip {
  background: #eff6ff;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #bfdbfe;
  margin-top: 24px;
  color: #1e40af;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
}
</style>
